import { request } from '@/api/request';
import type { ReassessmentStatus } from '@/types/models/reassessment';

const startReassessment = () => request<ReassessmentStatus>('POST', `/reassessment/start`);

const submitReassessment = () => request('POST', `/reassessment/complete`);

const getReassessmentStatus = () => request<ReassessmentStatus>('GET', '/reassessment/status');

export type ConfirmationResponse = {
  reassessmentStatus: ReassessmentStatus;
};

const confirmDomain = (domainID: string) =>
  request<ConfirmationResponse>('POST', `/reassessment/domain/${domainID}/confirm`);

const setAnswerConfirmation = (answerID: string, isConfirmed: boolean) =>
  request<ConfirmationResponse>('POST', `/reassessment/answers/${answerID}/set-confirmation`, {
    confirmed: isConfirmed,
  });

export default {
  startReassessment,
  submitReassessment,
  getReassessmentStatus,
  confirmDomain,
  setAnswerConfirmation,
};
